import { useDataSubmit, useDataChange } from 'Simple/Data.js'
import { normalizePath, useSetFlowTo } from 'Simple/Flow.js'

export function useOnClick(props) {
  let setFlowTo = useSetFlowTo(props.viewPath)

  let setLoading = useDataChange({
    context: 'loading',
    viewPath: props.viewPath,
  })

  let submit = useDataSubmit({
    viewPath: props.viewPath,
    context: 'task',
  })

  return async function onClick() {
    setLoading(true)
    try {
      await submit({ type: 'generate_letter' })
      setFlowTo(normalizePath(props.viewPath, '../../No'))
    } finally {
      setLoading(false)
    }
  }
}
